/* ============================================================
   OLIMAN TAVAN VANTİLATÖRÜ — Yaprak Site Script
   Sipariş formu linki için aşağıdaki ORDER_FORM_URL'i doldurun.
   ============================================================ */


document.addEventListener('DOMContentLoaded', function () {
    setupSmoothScroll();
    setupScrollReveal();
    setupCounterAnimation();
    setupBottomBar();
    setupFloatingElements();
    startSocialProofLoop();
    setupCountdown();
    setupStockBar();
    setupTilt();
    setupMagnetic();
    setupLightbox();
    setupBolgeSelector();
    setupFaq();
    setupHeroGallery();
    setupPackages();
});

function setupNavbar() {
    var navbar = document.getElementById('navbar');
    if (!navbar) return;
    window.addEventListener('scroll', function () {
        if (window.scrollY > 40) navbar.classList.add('scrolled');
        else navbar.classList.remove('scrolled');
    }, { passive: true });
}

function setupMobileMenu() {
    var btn = document.getElementById('hamburger');
    var menu = document.getElementById('navMenu');
    var nav = document.getElementById('navbar');
    if (!btn || !menu) return;
    function setOpen(open) {
        btn.classList.toggle('open', open);
        menu.classList.toggle('open', open);
        if (nav) nav.classList.toggle('nav-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
    }
    btn.addEventListener('click', function () { setOpen(!menu.classList.contains('open')); });
    var links = menu.querySelectorAll('.nav-link');
    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function () { setOpen(false); });
    }
}

function setupSmoothScroll() {
    var anchors = document.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < anchors.length; i++) {
        anchors[i].addEventListener('click', function (e) {
            var href = this.getAttribute('href');
            if (href === '#') return;
            var target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                var offset = 90;
                var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        });
    }
}

function setupScrollReveal() {
    var items = document.querySelectorAll('.reveal-el');
    if (!items.length) return;
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var parent = entry.target.parentElement;
                var siblings = [];
                if (parent) {
                    var children = parent.children;
                    for (var j = 0; j < children.length; j++) {
                        if (children[j].classList.contains('reveal-el')) siblings.push(children[j]);
                    }
                }
                var idx = siblings.indexOf(entry.target);
                var delay = idx >= 0 ? idx * 90 : 0;
                setTimeout(function () { entry.target.classList.add('visible'); }, delay);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { observer.observe(el); });
}

function setupCounterAnimation() {
    var nums = document.querySelectorAll('.hl strong');
    if (!nums.length) return;
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var el = entry.target;
                var target = parseInt(el.textContent, 10);
                if (isNaN(target)) return;
                runCounter(el, 0, target, 800);
                observer.unobserve(el);
            }
        });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { observer.observe(n); });
}

function runCounter(el, from, to, duration) {
    var start = performance.now();
    function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(from + (to - from) * eased);
        if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
}

function setupBottomBar() {
    var bar = document.getElementById('bottomBar');
    if (!bar) return;
    window.addEventListener('scroll', function () {
        if (window.scrollY > 400) bar.classList.add('show');
        else bar.classList.remove('show');
    }, { passive: true });
}

function setupFloatingElements() {
    var waBtn = document.getElementById('whatsappBtn');
    window.addEventListener('scroll', function () {
        if (waBtn) {
            if (window.scrollY > 500) waBtn.classList.add('show');
            else waBtn.classList.remove('show');
        }
    }, { passive: true });
}

function setupActiveNavTracking() {
    var sections = document.querySelectorAll('section[id]');
    var links = document.querySelectorAll('.nav-link');
    window.addEventListener('scroll', function () {
        var scrollPos = window.scrollY + 150;
        var current = '';
        sections.forEach(function (sec) {
            if (scrollPos >= sec.offsetTop && scrollPos < sec.offsetTop + sec.offsetHeight) current = sec.getAttribute('id');
        });
        links.forEach(function (link) {
            link.classList.remove('active');
            if (link.getAttribute('href') === '#' + current) link.classList.add('active');
        });
    }, { passive: true });
}

function setupScrollProgress() {
    var bar = document.getElementById('scrollProgress');
    if (!bar) return;
    function update() {
        var h = document.documentElement;
        var height = h.scrollHeight - h.clientHeight;
        bar.style.width = (height > 0 ? (h.scrollTop / height) * 100 : 0) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
}

/* GERİ SAYIM — 24 saatlik, tarayıcıda saklanan kampanya penceresi */
function setupCountdown() {
    var hEl = document.getElementById('cdH'), mEl = document.getElementById('cdM'), sEl = document.getElementById('cdS');
    if (!hEl || !mEl || !sEl) return;
    var WINDOW_MS = 24 * 60 * 60 * 1000;
    var KEY = 'oliman_cd_deadline';
    var deadline;
    try {
        var stored = localStorage.getItem(KEY);
        deadline = stored ? parseInt(stored, 10) : NaN;
        if (isNaN(deadline) || deadline < Date.now()) {
            deadline = Date.now() + WINDOW_MS;
            localStorage.setItem(KEY, String(deadline));
        }
    } catch (e) { deadline = Date.now() + WINDOW_MS; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
            deadline = Date.now() + WINDOW_MS;
            try { localStorage.setItem(KEY, String(deadline)); } catch (e) {}
            diff = WINDOW_MS;
        }
        var t = Math.floor(diff / 1000);
        hEl.textContent = pad(Math.floor(t / 3600));
        mEl.textContent = pad(Math.floor((t % 3600) / 60));
        sEl.textContent = pad(t % 60);
    }
    tick();
    setInterval(tick, 1000);
}

/* AZALAN STOK ÇUBUĞU */
function setupStockBar() {
    var fill = document.getElementById('stockFill');
    var label = document.getElementById('stockLabel');
    if (!fill) return;
    var C = window.OLV26 || {}; var total = C.stockTotal || 50, remaining = C.stockLeft || 9;
    var soldPct = Math.round(((total - remaining) / total) * 100);
    if (label) label.textContent = remaining + ' / ' + total + ' adet kaldı';
    var done = false;
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting && !done) {
                done = true;
                requestAnimationFrame(function () { fill.style.width = soldPct + '%'; });
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.4 });
    observer.observe(fill);
}

/* 3D TILT */
function setupTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
        var max = 10;
        el.addEventListener('mousemove', function (e) {
            var r = el.getBoundingClientRect();
            var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
            var rx = (py - 0.5) * -2 * max, ry = (px - 0.5) * 2 * max;
            el.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-6px)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
}

/* MANYETİK BUTON */
function setupMagnetic() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-magnetic]').forEach(function (el) {
        var s = 0.35;
        el.addEventListener('mousemove', function (e) {
            var r = el.getBoundingClientRect();
            var x = (e.clientX - r.left - r.width / 2) * s, y = (e.clientY - r.top - r.height / 2) * s;
            el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) translateY(-3px)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
}

/* GALERİ LIGHTBOX */
function setupLightbox() {
    var lb = document.getElementById('lightbox'), lbImg = document.getElementById('lbImg');
    var closeBtn = document.getElementById('lbClose'), prevBtn = document.getElementById('lbPrev'), nextBtn = document.getElementById('lbNext');
    if (!lb || !lbImg) return;
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox]'));
    var sources = triggers.map(function (t) { return t.getAttribute('data-lightbox'); });
    var sourcesMobile = triggers.map(function (t) { return t.getAttribute('data-lightbox-mobile') || t.getAttribute('data-lightbox'); });
    var current = 0;
    function pick(i) { return (window.matchMedia('(max-width:768px)').matches ? sourcesMobile : sources)[i]; }
    function open(i) { current = i; lbImg.setAttribute('src', pick(current)); lb.classList.add('open'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { lb.classList.remove('open'); lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    function show(d) { current = (current + d + sources.length) % sources.length; lbImg.setAttribute('src', pick(current)); }
    triggers.forEach(function (t, i) { t.addEventListener('click', function () { open(i); }); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(1);
        else if (e.key === 'ArrowLeft') show(-1);
    });
}

/* BÖLGE SEÇİCİ */
var bolgeData = {
    boyun: { ico: '🧣', title: 'Boyun Bölgesi', text: 'Uzun çalışma saatleri ve ekran başında geçen günlerin ardından boyun bölgesine masajla uygulayın; termal his ile konforlu bir bakım ritüeli oluşturun.' },
    omuz:  { ico: '💪', title: 'Omuz Bölgesi', text: 'Gün boyu yük taşıyan omuzlara masajla uygulandığında ferah ve sıcak karakterli bir konfor hissini destekler.' },
    bel:   { ico: '🧍', title: 'Bel Bölgesi', text: 'Uzun süre ayakta kalan ya da masa başında çalışanlar için bel bölgesine pratik bir günlük bakım dokunuşu.' },
    diz:   { ico: '🦵', title: 'Diz Bölgesi', text: 'Spor sonrası veya günlük tempo ardından dizlere masajla uygulayın; termal konfor hissiyle ferahlatıcı bir bakım.' },
    bilek: { ico: '✋', title: 'Bilek Bölgesi', text: 'Gün içinde yoğun kullanılan bileklere kolay uygulama; hızlı emilen, yağsız his bırakmayan pratik bakım.' },
    baldir:{ ico: '🦿', title: 'Baldır Bölgesi', text: 'Gün sonunda yorulan baldırlara masajla uygulandığında ferah bir bakım rutini ve termal konfor hissi sunar.' }
};

function setupBolgeSelector() {
    var chips = document.querySelectorAll('.bolge-chip');
    var panel = document.getElementById('bolgePanel');
    if (!chips.length || !panel) return;
    chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
            chips.forEach(function (c) { c.classList.remove('active'); });
            chip.classList.add('active');
            var key = chip.getAttribute('data-bolge');
            var d = bolgeData[key];
            if (!d) return;
            panel.innerHTML = '<div class="bp-ico">' + d.ico + '</div><h3>' + d.title + '</h3><p>' + d.text + '</p>';
        });
    });
}

/* TICKER */
var tickerMessages = [
    { icon: '🌿', text: '<strong>22.000+</strong> mutlu kullanıcı Olbiy\'i tercih etti' },
    { icon: '👁️', text: 'Şu anda <strong>34</strong> kişi bu ürünü inceliyor' },
    { icon: '📦', text: 'Kampanya stoğunda sadece <strong>9</strong> adet kaldı!' },
    { icon: '🛒', text: 'Son <strong>1 saat</strong> içinde <strong>6</strong> sipariş verildi' },
    { icon: '⭐', text: 'Müşteri puanı <strong>4.8/5</strong>' },
    { icon: '🦟', text: 'Yaz akşamları için <strong>botanik koruma</strong> bir arada' },
    { icon: '🚚', text: 'Siparişler <strong>aynı gün</strong> kargoya veriliyor' },
    { icon: '🌿', text: '<strong>9 botanik</strong> içerikli vetiver özlü formül' }
];
var tickerIndex = 0;
function startTickerRotation() {
    setInterval(function () { tickerIndex = (tickerIndex + 1) % tickerMessages.length; updateTicker(); }, 4000);
}
function updateTicker() {
    var el = document.getElementById('tickerContent');
    if (!el) return;
    var msg = tickerMessages[tickerIndex];
    el.style.opacity = '0'; el.style.transform = 'translateY(8px)';
    setTimeout(function () {
        el.innerHTML = '<span>' + msg.icon + ' ' + msg.text + '</span>';
        el.style.opacity = '1'; el.style.transform = 'translateY(0)';
    }, 300);
}

/* SOSYAL KANIT */
var spData = [
    { type: 'order', name: 'Ayşe K.', city: 'İstanbul', time: '2 dakika önce' },
    { type: 'order', name: 'Mehmet T.', city: 'Ankara', time: '5 dakika önce' },
    { type: 'order', name: 'Elif S.', city: 'İzmir', time: '3 dakika önce' },
    { type: 'order', name: 'Ahmet B.', city: 'Bursa', time: '7 dakika önce' },
    { type: 'order', name: 'Zeynep M.', city: 'Antalya', time: '4 dakika önce' },
    { type: 'order', name: 'Can D.', city: 'Konya', time: '6 dakika önce' },
    { type: 'order', name: 'Selin Y.', city: 'Adana', time: '8 dakika önce' },
    { type: 'order', name: 'Derya K.', city: 'Gaziantep', time: '1 dakika önce' },
    { type: 'order', name: 'Fatma T.', city: 'Eskişehir', time: '3 dakika önce' },
    { type: 'order', name: 'Murat E.', city: 'Samsun', time: '5 dakika önce' },
    { type: 'stock', count: 7 },
    { type: 'stock', count: 4 },
    { type: 'viewers', count: 28 },
    { type: 'viewers', count: 36 },
    { type: 'sold', count: 184 },
    { type: 'sold', count: 312 }
];
var spIndex = 0;
function startSocialProofLoop() {
    shuffleArray(spData);
    setTimeout(function () { showNextProof(); }, 5000);
}
function showNextProof() {
    showSocialProof(spData[spIndex]);
    spIndex = (spIndex + 1) % spData.length;
    if (spIndex === 0) shuffleArray(spData);
}
function showSocialProof(data) {
    var box = document.getElementById('socialProof'), content = document.getElementById('spContent');
    if (!box || !content) return;
    var html = '';
    var colors = ['#f5b301', '#ff8a00', '#ffd24a', '#ff5e1a', '#e09a00', '#ffb347'];
    var pick = colors[Math.floor(Math.random() * colors.length)];
    if (data.type === 'order') {
        html = '<div class="sp-icon" style="background:' + pick + '">' + data.name.charAt(0) + '</div>';
        html += '<div class="sp-text"><strong>' + data.name + ' (' + data.city + ') sipariş verdi</strong><small>✅ Doğrulanmış &bull; ' + data.time + '</small></div>';
    } else if (data.type === 'stock') {
        html = '<div class="sp-icon" style="background:#ff5e1a">⚡</div><div class="sp-text"><strong>Stokta sadece ' + data.count + ' adet kaldı!</strong><small>🔥 Yoğun talep devam ediyor</small></div>';
    } else if (data.type === 'viewers') {
        html = '<div class="sp-icon" style="background:#ff8a00">👁️</div><div class="sp-text"><strong>Şu anda ' + data.count + ' kişi bu ürünü inceliyor</strong><small>📈 Popüler ürün</small></div>';
    } else if (data.type === 'sold') {
        html = '<div class="sp-icon" style="background:#f5b301">🎉</div><div class="sp-text"><strong>Bu ay ' + data.count + ' kişi sipariş verdi</strong><small>⭐ En çok tercih edilen ürün</small></div>';
    }
    content.innerHTML = html;
    box.classList.add('show');
    setTimeout(function () {
        box.classList.remove('show');
        setTimeout(function () { showNextProof(); }, 800);
    }, 4200);
}
document.addEventListener('click', function (e) {
    if (e.target.classList.contains('sp-close') || e.target.closest('.sp-close')) {
        var box = document.getElementById('socialProof');
        if (box) box.classList.remove('show');
    }
});
function shuffleArray(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
}

/* SİPARİŞ MODALI */
function setupOrderModal() {
    var orderBtns = document.querySelectorAll('a[href="#siparis"], .bottom-bar-btn');
    var overlay = document.getElementById('orderModalOverlay');
    if (!overlay) return;
    orderBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var menu = document.getElementById('navMenu'), hamburger = document.getElementById('hamburger');
            if (menu && menu.classList.contains('open')) {
                menu.classList.remove('open');
                if (hamburger) hamburger.classList.remove('open');
            }
            openOrderModal();
        });
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOrderModal(); });
}

function openOrderModal() {
    var overlay = document.getElementById('orderModalOverlay');
    var frame = document.getElementById('orderFrame');
    var fallback = document.getElementById('orderFallback');
    if (!overlay) return;
    if (ORDER_FORM_URL && frame) {
        if (!frame.getAttribute('src')) frame.setAttribute('src', ORDER_FORM_URL);
        frame.style.display = 'block';
        if (fallback) fallback.style.display = 'none';
    } else {
        if (frame) frame.style.display = 'none';
        if (fallback) fallback.style.display = 'flex';
    }
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
}

function closeOrderModal() {
    var overlay = document.getElementById('orderModalOverlay');
    if (overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; }
}

window.openOrderModal = openOrderModal;
window.closeOrderModal = closeOrderModal;

document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOrderModal(); });

/* Stoktv form otomatik yükseklik eşitleyici */

/* Stoktv form otomatik yükseklik eşitleyici */
window.addEventListener('message', function (e) {
    if (e.data && e.data.type === 'setHeight' && typeof e.data.height === 'number') {
        var iframe = document.getElementById('orderFrame');
        if (iframe && e.data.height > iframe.offsetHeight + 5) {
            iframe.style.setProperty('--iframe-height', (e.data.height + 10) + 'px', 'important');
        }
    }
});

/* SSS AKORDEON */
function setupFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.faq-item'));
    items.forEach(function (item) {
        var q = item.querySelector('.faq-q');
        var a = item.querySelector('.faq-a');
        if (!q || !a) return;
        q.addEventListener('click', function () {
            var isOpen = item.classList.contains('open');
            items.forEach(function (it) {
                it.classList.remove('open');
                var aa = it.querySelector('.faq-a');
                if (aa) aa.style.maxHeight = null;
            });
            if (!isOpen) {
                item.classList.add('open');
                a.style.maxHeight = a.scrollHeight + 'px';
            }
        });
    });
}

/* YORUM CAROUSEL */
function setupReviewCarousel() {
    var track = document.getElementById('yorumTrack');
    var prev = document.getElementById('yorumPrev');
    var next = document.getElementById('yorumNext');
    if (!track) return;
    function step() {
        var card = track.querySelector('.yorum-card');
        return card ? card.getBoundingClientRect().width + 20 : 360;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
}

/* HERO ÜRÜN GALERİSİ */
function setupHeroGallery() {
    var main = document.getElementById('hgMain');
    var thumbs = document.querySelectorAll('.hg-thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
            var src = t.getAttribute('data-img');
            if (!src) return;
            main.style.opacity = '0';
            setTimeout(function () { main.setAttribute('src', src); main.style.opacity = '1'; }, 150);
            thumbs.forEach(function (x) { x.classList.remove('active'); });
            t.classList.add('active');
        });
    });
}

/* ============================================================
   PAKET SEÇİMİ + PAKET MODALI (Shopify sepet/checkout)
   ============================================================ */
function setupPackages() {
    var CFG = window.OLV26 || {};
    var modal = document.getElementById('pkgModal');
    var hidden = document.getElementById('olvVariantId');
    var promoPrice = document.getElementById('promoPrice');
    var totalInline = document.getElementById('pkgTotalInline');
    var totalModal = document.getElementById('pkgTotalModal');

    /* --- kart seçimi --- */
    function bindGroup(root, onPick) {
        if (!root) return;
        var cards = root.querySelectorAll('.pkg-card');
        for (var i = 0; i < cards.length; i++) {
            (function (card) {
                card.addEventListener('click', function () {
                    if (card.classList.contains('pkg-out')) return;
                    for (var j = 0; j < cards.length; j++) cards[j].classList.remove('sel');
                    card.classList.add('sel');
                    var input = card.querySelector('input[type="radio"]');
                    if (input) input.checked = true;
                    onPick(card);
                });
            })(cards[i]);
        }
    }

    /* seçimi iki grup arasında senkronla */
    function syncTo(root, vid) {
        if (!root) return;
        var cards = root.querySelectorAll('.pkg-card');
        for (var i = 0; i < cards.length; i++) {
            var on = cards[i].getAttribute('data-vid') === String(vid);
            cards[i].classList.toggle('sel', on);
            var inp = cards[i].querySelector('input[type="radio"]');
            if (inp) inp.checked = on;
        }
    }

    var inline = document.getElementById('pkgInline');
    var mwrap = document.getElementById('pkgModalWrap');

    function pick(card, from) {
        var vid = card.getAttribute('data-vid');
        var total = card.getAttribute('data-total');
        var price = card.getAttribute('data-price');
        if (hidden) hidden.value = vid;
        if (promoPrice && price) promoPrice.textContent = price;
        if (totalInline && total) totalInline.textContent = total;
        if (totalModal && total) totalModal.textContent = total;
        if (from !== 'inline') syncTo(inline, vid);
        if (from !== 'modal') syncTo(mwrap, vid);
    }

    bindGroup(inline, function (c) { pick(c, 'inline'); });
    bindGroup(mwrap, function (c) { pick(c, 'modal'); });

    /* --- modal aç/kapat --- */
    var opener = document.querySelectorAll('[data-pkg-open]');
    function openModal(e) {
        if (!modal) return;
        if (e) e.preventDefault();
        modal.classList.add('open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }
    function closeModal() {
        if (!modal) return;
        modal.classList.remove('open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }
    for (var i = 0; i < opener.length; i++) opener[i].addEventListener('click', openModal);
    if (modal) {
        var closers = modal.querySelectorAll('[data-pkg-close]');
        for (var k = 0; k < closers.length; k++) closers[k].addEventListener('click', closeModal);
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closeModal();
        });
    }

    /* --- modaldan sepete ekle + checkout --- */
    var go = document.getElementById('pkgGo');
    if (go) {
        go.addEventListener('click', function () {
            var vid = null;
            if (mwrap) {
                var sel = mwrap.querySelector('.pkg-card.sel');
                if (sel) vid = sel.getAttribute('data-vid');
            }
            if (!vid) {
                var single = document.getElementById('pkgSingleId');
                if (single) vid = single.value;
            }
            if (!vid && hidden) vid = hidden.value;
            if (!vid) return;

            var addUrl = CFG.cartAddUrl || '/cart/add';
            go.disabled = true;
            var oldTxt = go.innerHTML;
            go.innerHTML = 'Sepete ekleniyor...';

            fetch(addUrl + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
            }).then(function (r) {
                if (!r.ok) throw new Error('cart');
                return r.json();
            }).then(function () {
                window.location.href = '/checkout';
            }).catch(function () {
                /* AJAX başarısızsa klasik form gönderimine düş */
                var f = document.createElement('form');
                f.method = 'post';
                f.action = addUrl;
                var a = document.createElement('input');
                a.type = 'hidden'; a.name = 'id'; a.value = vid;
                var b = document.createElement('input');
                b.type = 'hidden'; b.name = 'quantity'; b.value = '1';
                f.appendChild(a); f.appendChild(b);
                document.body.appendChild(f);
                f.submit();
            });
            setTimeout(function () { go.disabled = false; go.innerHTML = oldTxt; }, 6000);
        });
    }
}
